import { routeConstants } from "constants/routeConstants";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "slice";
import { useCheckoutMutation, useGetPlansQuery } from "slice/pricing";

export const usePricing = () => {
    const [duration, setDuration] = useState("monthly");
    const { id } = useAppSelector((state) => state.user);
    const { planId } = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [plans, setPlans] = useState([]);
    const [planSelected, setPlanSelected] = useState("");

    const { data: plansData, isLoading: plansLoading, error: plansError } = useGetPlansQuery(
        { user_id: id || "" },
        { skip: !id }
    );

    const [checkout, { data: checkoutData, isLoading: isLoadingCheckout }] =
        useCheckoutMutation();

    const handleDurationChange = useCallback((val) => setDuration(val), []);

    const handleChoosePlan = useCallback(
        (planId) => {
            setPlanSelected(planId);
            checkout({
                price_id: planId,
                user_id: id || "",
                success_url:
                    window.location.origin + routeConstants.purchase.success,
                cancel_url:
                    window.location.origin + routeConstants.purchase.cancel,
            });
        },
        [checkout, id]
    );

    useEffect(() => {
        if (plansData && plansData.plan_list) {
            const { monthly_plans, yearly_plans } = plansData.plan_list;

            // Combine monthly and yearly plans
            const allPlans = [
                ...monthly_plans.map((plan, index) => ({
                    id: plan.id,
                    monthlyPrice: plan.amount,
                    yearlyPrice: yearly_plans[index] ? yearly_plans[index].amount : 0,
                    name: plan.metadata.name,
                    type: plan.metadata.type,
                    currency: plan.currency,
                    isCurrent: index === 0,
                    benefits: plan.metadata.benefits.split(","),
                    interval: 'month'
                })),
                ...yearly_plans.map((plan, index) => ({
                    id: plan.id,
                    monthlyPrice: monthly_plans[index] ? monthly_plans[index].amount : 0,
                    yearlyPrice: plan.amount,
                    name: plan.metadata.name,
                    type: plan.metadata.type,
                    currency: plan.currency,
                    isCurrent: index === 0,
                    benefits: plan.metadata.benefits.split(","),
                    interval: 'year'
                }))
            ];


            // Sort allPlans by monthlyPrice
            allPlans.sort((a, b) => a.monthlyPrice - b.monthlyPrice);

            setPlans(allPlans);

            const id = setTimeout(() => setIsLoading(false), 200);

            return () => clearTimeout(id);
        }
    }, [plansData]);


    useEffect(() => {
        if (planId) {
            setIsLoading(true);
            handleChoosePlan(planId);
        }
    }, [planId, handleChoosePlan]);

    useEffect(() => {
        if (checkoutData) {
            window.location.href = checkoutData.session.url;
        }
    }, [checkoutData]);

    return {
        duration,
        plans,
        planId,
        handleDurationChange,
        planSelected,
        isFetchingPlans: isLoading || plansLoading,
        handleChoosePlan,
        isLoadingCheckout,
    };
};
